<template>
  <div class="rental-info">
    <template v-if="cabinet && cabinet.priceStrategy.pType !== 2">
      <section class="pricing-section">
        <h3>{{ i18n.rental_pricing }}</h3>
        <ul>
          <li>{{ shopPriceDesc(i18n.rentalPriceDesc) }}</li>
          <li>{{ shopPriceDesc(i18n.rentalPriceDesc1) }}</li>
          <li>{{ shopPriceDesc(i18n.rentalPriceDesc2) }}</li>
          <!-- <li>{{ shopPriceDesc(i18n.rentalPriceDesc3) }}</li> -->
        </ul>
      </section>

      <section class="free-period-section">
        <h3>{{ i18n.free_period }}</h3>
        <ul>
          <li>{{ shopPriceDesc(i18n.free_period_desc) }}</li>
        </ul>
      </section>

      <section class="deposit-section">
        <h3>{{ $t("mine.deposit") }}:</h3>
        <ul>
          <li>{{ shopPriceDesc(i18n.deposit_desc_1) }}</li>
          <li>
            {{ i18n.deposit_desc_2 }}
            <!-- <ul>
              <li>{{ i18n.deposit_with_desc_1 }}</li>
              <li>{{ i18n.deposit_with_desc_2 }}</li>
            </ul> -->
          </li>
          <li>{{ i18n.deposit_desc_vary }}</li>
        </ul>
      </section>
      <section class="return-policy-section">
        <h3>{{ i18n.return_policy }}</h3>
        <ul>
          <li>{{ i18n.return_policy_company }}</li>
          <li>{{ shopPriceDesc(i18n.return_policy_late) }}</li>
        </ul>
      </section>
    </template>
    <template v-else-if="cabinet && cabinet.priceStrategy">
      <section class="pricing-section">
        <h3>Rental Pricing Policy for This Machine:</h3>
        <ul>
          <li>
            Deposit Required:{{ cabinet.currency
            }}{{ cabinet.yajin }}(Refundable after deduction of rental fee).
          </li>
          <li
            :key="item.pId"
            v-for="item in cabinet.priceStrategy.priceStrategyDetail"
            style="display: flex;justify-content: space-between;"
          >
            <td>
              Time interval：{{ item.pStartMinute }}~{{ item.pEndMinute }} Min
            </td>
            <td class="text-success">
              Cost <b>{{ cabinet.currency }} {{ item.pTotalFee }}</b>
            </td>
            <!-- <p>时段：{{ item.pStartMinute }}~{{ item.pEndMinute }} 分钟</p>
            <p>时段收费金额 <b>{{ item.pTotalFee }}</b></p> -->
          </li>
        </ul>
      </section>
      <section class="free-period-section">
        <h3>Return:</h3>
        <ul>
          <li>
            {{ shopPriceDesc(i18n.rentalPriceDesc2) }}
          </li>
        </ul>
      </section>
      <section class="free-period-section">
        <h3>Deposit:</h3>
        <ul>
          <li>
            The remaining Deposit(after deductions)will be automatically
            refunded your bank account within 3-30 minutes. No notification will
            be sent.
          </li>
          <li>{{ i18n.deposit_desc_vary }}</li>
          <li>
            Refunds will be processed directly through your bank account. SMS
            notifications may differ depending on your bank's policies.
          </li>
        </ul>
      </section>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "RentalPricingInfo",
  computed: {
    ...mapState(["lang"]),
    i18n() {
      return this.$t("home");
    }
  },
  props: {
    cabinet: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    /**
     * 价格描述格式化
     */
    shopPriceDesc(desc) {
      let cabinet = { ...this.cabinet };
      if (cabinet.priceStrategy) {
        cabinet = { ...this.cabinet.priceStrategy, ...this.cabinet, priceUnitSrting: this.$priceUnit(this.cabinet.priceStrategy.priceUnit) };
      }
      return `${desc}`.format(cabinet);
    }
  },
  created() {},
  mounted() {
    console.log(" ~ cabinet:", this.cabinet);
  }
};
</script>

<style scoped lang="less">
.rental-info {
  font-family: Arial, sans-serif;
  line-height: 1.5;
  padding: 20px;
  border-radius: 4px;
  font-size: 28px;
  section {
    margin-bottom: 20px;
  }

  h3 {
    margin-bottom: 10px;
    color: #333;
  }

  ul {
    margin: 0;
    padding-left: 20px;
    color: #555;
    li {
      list-style: initial;
    }
  }

  ul ul {
    padding-left: 15px;
    margin-top: 5px;
    li {
      list-style: none;
    }
  }
}
</style>
